<div class="dog-container">
  <div *ngIf="showReleaseError" class="error-box alt p-15 text-center">
    <img
      height="24"
      width="24"
      src="../../../../assets/svg/ico_error_circle.svg"
    />
    <p class="error-box-text">
      Signed Terms & Policies are required in order to bring your dog for
      their interview. Please review and sign Terms & Policies in “My
      Profile”.
    </p>
  </div>
  <app-camper-list [petTileList]="petTileList"></app-camper-list>
  <div class="d-flex justify-content-center"
       tabindex="0">
    <button
      class="btn btn-outline-danger add-pet-btn"
      (click)="navigateToDogProfileAdd()"
      tabindex="0">
      Add a Camper
    </button>
  </div>
</div>
